import { render } from "./ProductSelectSlot.vue?vue&type=template&id=99511a7c"
import script from "./ProductSelectSlot.vue?vue&type=script&lang=js"
export * from "./ProductSelectSlot.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__